import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithubSquare, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import * as S from "./style";

const email = "joao.p.ferreira.maciel@gmail.com";

const SocialMedia = () => {
  const { t } = useTranslation("home");

  return (
    <S.Container>
      <S.Title>{t("contact")}</S.Title>
      <S.Description>{t("contactPrompt")}</S.Description>
      <S.LinkList>
        <S.SocialLink href={`mailto:${email}`}>
          <FontAwesomeIcon icon={faEnvelope} aria-hidden="true" />
          <span>
            {t("email")}: {email}
          </span>
        </S.SocialLink>
        <S.SocialLink
          href="https://www.linkedin.com/in/zaconou/"
          target="_blank"
          rel="noreferrer"
        >
          <FontAwesomeIcon icon={faLinkedin} aria-hidden="true" />
          <span>{t("linkedin")}</span>
        </S.SocialLink>
        <S.SocialLink
          href="https://github.com/joaopedromago"
          target="_blank"
          rel="noreferrer"
        >
          <FontAwesomeIcon icon={faGithubSquare} aria-hidden="true" />
          <span>{t("github")}</span>
        </S.SocialLink>
      </S.LinkList>
    </S.Container>
  );
};

export default SocialMedia;
